// TrustCenterHeader.jsx
import UnifiedIcon from '../../../components/UnifiedIcon';
import KincodeButton from '../../../components/button/KincodeButton';
import Configs from '../../../Configs';

import { useTranslation } from 'react-i18next';

export default function TrustCenterHeader({
  companyName,
  companyLogo,
  isMock,
  primaryColorHex,
  buttonTheme,
  onShare,
  title,
  subtitle,
}) {
  const { t } = useTranslation(['trust-center']);
  const displayLogo = companyLogo || Configs.companyLogoSmall;


  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------
  return (
    <header className="mb-6 rounded-2xl bg-white/80 backdrop-blur border border-gray-100 px-3 py-3 md:px-6 md:py-4 shadow-sm flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div className="flex items-center gap-3 min-w-0">
        <div className="h-10 w-10 rounded-full bg-gray-50 border border-gray-100 flex items-center justify-center overflow-hidden flex-shrink-0">
          <img
            src={displayLogo}
            alt={companyName}
            className="h-8 w-8 object-contain"
            loading="lazy"
          />
        </div>
        <div className="min-w-0 text-left">
          <div className="text-xs uppercase tracking-[0.22em] text-gray-400 flex items-center gap-2">
            <span className="font-medium text-gray-500">Kincode AI</span>
            <span className="inline-flex h-1 w-1 rounded-full bg-gray-300" />
            <span className="truncate">{t('trust-center.header.title')}</span>
          </div>
          <h1 className="mt-1 text-xl md:text-2xl font-semibold text-gray-900 truncate">
            {title}
          </h1>
          <p className="mt-1 text-xs md:text-sm text-gray-500 line-clamp-2">{subtitle}</p>
          {isMock && (
            <span className="mt-1 inline-flex items-center gap-1 rounded-full bg-amber-50 border border-amber-100 px-2 py-0.5 text-[10px] font-medium text-amber-700">
              <span className="h-1.5 w-1.5 rounded-full bg-amber-400" />
              Example data
            </span>
          )}
        </div>
      </div>

      <div className="flex-shrink-0 w-full md:w-auto flex md:justify-end">
        <KincodeButton
          variant="primary"
          theme={buttonTheme}
          colorHex={primaryColorHex}
          onClick={onShare}
          ariaLabel="Share Trust Center link"
          size="sm"
        >
          <UnifiedIcon name="ShareNetwork" library="phosphor" className="h-4 w-4" />
          <span className="text-sm">{t('trust-center.header.share')}</span>
        </KincodeButton>
      </div>
    </header>
  );
}
